import { jsxs as n, jsx as l } from "react/jsx-runtime";
import { useRef as w, useEffect as N } from "react";
import { CloseSquareIcon as k } from "../../assets/icons/close-square.js";
import { cn as s } from "../../utils/cn.js";
const T = ({ children: b, isOpen: o, onClose: a, title: c, address: f, height: e = "md", isBorderHidden: p = !1 }) => {
  const i = w(null);
  return N(() => {
    if (!o || e === "full")
      return;
    let u, m;
    const x = (d) => {
      var r;
      u = ((r = d.touches[0]) == null ? void 0 : r.clientY) ?? 0;
    }, v = (d) => {
      var r;
      m = ((r = d.touches[0]) == null ? void 0 : r.clientY) ?? 0;
    }, h = () => {
      m - u > 40 && a();
    }, t = i.current;
    return t && (t.addEventListener("touchstart", x), t.addEventListener("touchmove", v), t.addEventListener("touchend", h)), () => {
      t && (t.removeEventListener("touchstart", x), t.removeEventListener("touchmove", v), t.removeEventListener("touchend", h));
    };
  }, [o, a, e]), /* @__PURE__ */ n("div", { className: "z-40 flex", children: [
    o && /* @__PURE__ */ l("div", { className: s("fixed inset-0 z-10 bg-black/35 dark:bg-white/35"), role: "presentation", onClick: a }),
    /* @__PURE__ */ n(
      "div",
      {
        ref: i,
        className: s(
          "bg-background fixed bottom-0 left-0 z-20 flex h-[60%] w-full translate-y-full transform flex-col shadow-lg transition-all duration-500",
          {
            "translate-y-0": o,
            "h-full": e === "full",
            "h-5/6 rounded-t-2xl": e === "xl",
            "h-4/6 rounded-t-2xl": e === "lg",
            "h-3/6 rounded-t-2xl": e === "md",
            "h-2/6 rounded-t-2xl": e === "sm"
          }
        ),
        style: {
          paddingTop: e === "full" ? "env(safe-area-inset-top)" : void 0
        },
        role: "dialog",
        children: [
          /* @__PURE__ */ l("div", { className: "absolute -top-4 left-1/2 -translate-x-1/2 p-2", children: /* @__PURE__ */ l("div", { className: "bg-background h-1 w-8 rounded-full" }) }),
          /* @__PURE__ */ n("div", { className: "flex flex-grow flex-col overflow-hidden rounded-t-2xl", children: [
            /* @__PURE__ */ n(
              "div",
              {
                className: s("flex items-center justify-between pb-2 pl-4 pr-2 pt-2", {
                  "pt-4": !!c,
                  "border-b border-black/5 dark:border-white/5": !p
                }),
                children: [
                  /* @__PURE__ */ n("div", { className: "flex flex-col", children: [
                    /* @__PURE__ */ l("h2", { className: "text-text text-title-1 font-normal", children: c }),
                    f && /* @__PURE__ */ l("p", { className: "text-subhead text-text-secondary", children: f })
                  ] }),
                  /* @__PURE__ */ l("button", { type: "button", onClick: a, children: /* @__PURE__ */ l(k, { className: "stroke-text h-10 w-10 fill-none p-2" }) })
                ]
              }
            ),
            /* @__PURE__ */ l("div", { className: "flex-grow overflow-y-auto pb-4", children: b })
          ] })
        ]
      }
    )
  ] });
};
export {
  T as Drawer
};
//# sourceMappingURL=index.js.map
